// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"3947f9a0753f64ce","6067":"9ca55af8dbba8145"}[chunkId] + ".css";
};